import {
  initialSupportDashboardState,
  SET_PATIENT_BILLING_DETAILS,
  RESET_SUPPORT_DASHBOARD,
} from './constants'

export const supportDashboardReducer = (
  state: SupportDashboardState = initialSupportDashboardState,
  // Type any is intentional here
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  action: ReducerActions<any>
): SupportDashboardState => {
  const { type: actionType, payload: actionPayload } = action

  switch (actionType) {
    case SET_PATIENT_BILLING_DETAILS:
      return {
        ...state,
        patientBillingDetails: actionPayload,
      }

    case RESET_SUPPORT_DASHBOARD:
      return initialSupportDashboardState

    default:
      return state
  }
}
